// extracted by mini-css-extract-plugin
module.exports = {"LogoMain":"LogoMain__LogoMain__1qVMD"};